import {EventListeners, MinzeElement, Reactive} from "minze";
import {Locale} from "../../modules/locale";
import {MODALS} from "../../constants";
import { SquidexTextLabels } from "../../modules/squidex/labels";

export interface TjContactPopupForm {
  query: string,
  submitted: boolean
}

Locale.getInstance().registerKeySet("fr", "contactPopupForm", {
  "title": "Contactez la Fondation Tel-Jeunes",
  "subtitle": "Remplissez le formulaire ci-dessous et nous vous contacterons dans les plus brefs délais.",
  "successMessage": `Demande envoyée!\n
  Nous communiquerons avec vous dans les plus brefs délais.`,
  "closeButton": "Fermer",
  "openButton": "Contactez-nous"
});

Locale.getInstance().registerKeySet("en", "contactPopupForm", {
  "title": "Contact Tel-Jeunes Foundation",
  "subtitle": "Fill out the form below and we will contact you as soon as possible.",
  "successMessage": `Request sent!\n
  We will contact you as soon as possible.`,
  "closeButton": "Close",
  "openButton": "Contact us"
});

export class TjContactPopupForm extends MinzeElement {
  reactive: Reactive = [
    ["submitted", false]
  ];
  isMobile = window.matchMedia("(max-width: 768px)").matches

  openModal() {
    const mainModule = window.TJ_MAIN_MODULE;
    mainModule.showModal(MODALS.CONTACT_POPUP);
  }

  closeModal() {
    const mainModule = window.TJ_MAIN_MODULE;
    mainModule.hideModal(MODALS.CONTACT_POPUP);
  }

  onSubmitted() {
    this.submitted = true;
    this.rerender();
  }

  html = () => /* html */ `
    <tj-popup-form
      data-modal-id="${MODALS.CONTACT_POPUP}"
      data-button-label="${SquidexTextLabels.getKey("contactPopupForm.openButton")}"
      data-button-size="small"
    >
      <div slot="tj-content">
        ${this.submitted ? `
          <tj-box display="flex" flexDirection="column" justifyContent="center" alignItems="center" padding="30px 0">
           <tj-text text-align="center" font-size="20px">
             ${SquidexTextLabels.getKey("contactPopupForm.successMessage")}
           </tj-text>
           <tj-box mt="32px" width="fit-content">
             <tj-button id="close-button" width="fit-content" size="small">
              ${SquidexTextLabels.getKey("contactPopupForm.closeButton")}
             </tj-button>
           </tj-box>
          </tj-box>
        ` : `
          <tj-box padding="${this.isMobile ? "0 0 10px" : "0"}" height="auto">
            <tj-background-arrow-icon></tj-background-arrow-icon>
            <tj-box mb="16px">
              <tj-text color="#133762" font-size="34px" font-weight="500">
                ${SquidexTextLabels.getKey("contactPopupForm.title")}
              </tj-text>
            </tj-box>
            <tj-box mb="32px">
              <tj-text color="#133762" font-size="16px">
                ${SquidexTextLabels.getKey("contactPopupForm.subtitle")}
              </tj-text>
            </tj-box>
            <tj-contact-form donationForm="true"></tj-contact-form>
          </tj-box>
        `}
      </div>
    </tj-popup-form>
  `;

  css = () => `
    tj-background-arrow-icon {
      position: absolute;
      top: 0;
      left: 0;
    }
  `;

  eventListeners: EventListeners = [
    ["#open-modal", "click", this.openModal],
    ["#close-button", "click", this.closeModal],
    [window, "tj:contact-form-submitted", this.onSubmitted.bind(this)]
  ];
}
